module.exports = __webpack_public_path__ + "img/college5.1f0173c9.png";